<div class="loading-overlay">
    <mat-spinner style="margin:100px auto"></mat-spinner>
</div>
